<div class="container-fluid">
  <page-header-search [isSearchInput]="true" [pageTitleValue]="pageTitle" [placeholderValue]="placeholder"
    (onHeaderInputKeyup)="onSearchKeyup($event)" (onHeaderSearchSubmit)="onSearchSubmit($event)"></page-header-search>

  <div class="row" *ngIf="!lcaPatientList?.length">
    <div class="col-12 text-center py-5">
      Hmm, There is no LCA patients to show! 🥳
    </div>
  </div>
  <div class="card mt-5">
    <div class="card-body">
      <div class="table-title">
        <h3 class="title mb-0">{{ tableTitle }}</h3>
        <button class="btn btn-neutral" (click)="exportToExcel()">
          <span class="btn-inner--icon">
            <i class="ni ni-cloud-download-95"> </i>
          </span>
          <span class="btn-inner--text"> Download as Excel </span>
        </button>
      </div>
      <ngx-datatable class="material ngx-datatable-custom" [rows]="filteredLcaPatientList" [columns]="columns"
        [limit]="pageSize" [offset]="currentPage-1" selectionType="single" [messages]="messages" (select)="routeToPatientDetails($event)" columnMode="force"
        externalPaging="true" [count]="totalItems" [scrollbarH]="true" [headerHeight]="50" [footerHeight]="50"
        rowHeight="auto" (page)="onChangePage($event)">
      </ngx-datatable>
    </div>
  </div>

</div>
<ngx-spinner></ngx-spinner>